;(function() {
  'use strict'

  controller.$inject = ["$scope", "glError", "facesService", "messagesService", "Message"];
  angular.module('app.messageList').controller('MessageList', controller)

  /* @ngInject */
  function controller($scope, glError, facesService, messagesService, Message) {
    $scope.Message = Message
    $scope.messages = messagesService.get()
    $scope.messages.promise.then(angular.noop, glError.fromStatus)

    $scope.moods = facesService.get()
    $scope.moodClass = moodClass

    function moodClass(message) {
      var mood =
        message.moodCurrent &&
        _.find($scope.moods, { value: message.moodCurrent })
      if (mood) {
        return '-visible ' + mood.iconClass
      }
    }
  }
})()
